export const MAPBOX_TOKEN = 'pk.eyJ1IjoicmFkb3NsYXcxMzM3IiwiYSI6ImNrdHN2OTRkNjE3dDQzMm5xd3hwZzJ2bmMifQ.9RcO9D0_fOdeJGF0NDEC_A';
export const GOOGLE_PLACES_API_KEY = 'AIzaSyCQoR-ZpFiD6nCQXA9Oy7fKPf_Cb2-l93s';

// these keys has been restricted to staging and production so wont work locally
// todo - add option to provide dev keys.